<template>
	<button
		class="d-inline-flex py-2 flex-column align-center tooth-btn"
		role="button"
		:style="computedStyles"
		:title="btnTitle"
		@click="emitClickEvent"
	>
		<span class="d-sr-only">
			{{ btnTitle }}
		</span>

		<span
			aria-hidden="true"
			class="font-weight-semibold"
		>
			{{ toothNumber }}
		</span>

		<img
			alt=""
			:src="require(`../../../assets/img/dental-chart-img/tooth-${toothNumber}.svg`)"
		>

		<span :class="milkTooth ? 'text-uppercase' : undefined">
			<span
				v-if="decayed && !missing"
				aria-hidden="true"
				class="text-body-1"
			>
				c
			</span>

			<span
				v-if="missing"
				aria-hidden="true"
				class="text-body-1"
			>
				a
			</span>

			<span
				v-if="filled && !missing"
				aria-hidden="true"
				class="text-body-1"
			>
				o
			</span>
		</span>
	</button>
</template>

<script setup lang="ts">
	import { IndexedObject } from '../../../types';
	import { computed } from 'vue';
	import { convertToHex } from '../../../functions/convertToHex';

	const props = defineProps({
		decayed: {
			type: Boolean,
			default: false,
		},
		filled: {
			type: Boolean,
			default: false,
		},
		milkTooth: {
			type: Boolean,
			default: false,
		},
		missing: {
			type: Boolean,
			default: false,
		},
		toothNumber: {
			type: String,
			required: true,
		},
	});

	const btnTitle = computed(() => {
		let title = `dent ${props.toothNumber}`;

		if (props.missing) {
			title += ' absente';
		} else {
			if (props.decayed) {
				title += ' cariée';
			}

			if (props.filled) {
				title += ' obturée';
			}
		}
		return title;
	});

	const computedStyles = computed(() => {
		const styles: IndexedObject = {};
		if (props.decayed || props.filled || props.missing) {
			styles.border = `1px solid ${convertToHex('ap-pink')}`;
		}
		return styles;
	});

	const emit = defineEmits(['click']);
	const emitClickEvent = (): void => {
		emit('click');
	};

</script>

<style lang="scss" scoped>
	.tooth-btn {
		border-radius: 8px;
		max-width: 100%;

		& img {

			margin: 8px 0;
			@media (max-width: 1239.999px) {
				width: 2.5rem;
			}

			@media (min-width: 1240px) {
				width: 3.125rem;
			}
		}
	}
</style>
